import Input from "./Input";
import Button from "./Button";
import TextArea from "./TextArea";
import Select from "./Select";

const Controls = {
  Button,
  Input,
  Select,
  TextArea,
};

export default Controls;
